import index from './tooltip'

export default index